import { Form } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { z } from "zod/v4";
import { toFormikValidationSchema } from "zod-formik-adapter";
import { useForm } from "../common/form/useForm";
import { ExtraForm } from "../common/pure/ExtraFormGroup";
import { PasswordSchema } from "../common/validations";
import { Button } from "../components/Button";
import { useBranding } from "../hooks/use-app-metadata";
import { AuthPage } from "../layout/AuthLayout";
import { useAuth } from "./useAuth";

const Schema = z.object({
	password: PasswordSchema,
});

export const PageForgotPasswordConsume = () => {
	const branding = useBranding();
	const { id, token } = useParams();
	const { resetConsume } = useAuth();
	const form = useForm({
		validationSchema: toFormikValidationSchema(Schema),
		initialValues: {
			password: "",
		},
		onSubmit: (values) => {
			if (!id || !token) {
				return;
			}

			return resetConsume.mutateAsync({
				id: Number(id),
				token,
				password: values.password,
			});
		},
	});

	return (
		<AuthPage title="Reset Password">
			<Form className="auth-form" onSubmit={form.handleSubmit}>
				<h1 className="mb-4">Reset password</h1>
				<p>Enter your new password to complete the password reset.</p>

				<ExtraForm.Group label="Password">
					<ExtraForm.Control
						placeholder="********"
						type="password"
						{...form.getFieldProps("password")}
						{...form.getFieldState("password")}
					/>
				</ExtraForm.Group>

				<Button full className="my-3" loading={form.isSubmitting} type="submit">
					Change password
				</Button>
				<footer>
					{branding.footerText ??
						`© ${new Date().getFullYear()} ${branding.appName}. All rights reserved`}
				</footer>
			</Form>
		</AuthPage>
	);
};
